import AppointmentPreviewApp from "../preview/AppointmentPreviewApp";
import { Button } from "antd";
import { t } from "i18next";
import { PlusOutlined } from "@ant-design/icons";
import React from "react";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { useModal } from "../../../core/context/ModalContext";
import { useHistory } from "react-router-dom";
import { PERMISSIONS, useUser } from "../../../core/context/UserContext";

export default function AppointmentIdColumn({ text, row, onSelect }) {
    const { refreshDataGrid } = useDataGrid()
    const history = useHistory()
    const { openModal } = useModal()
    const { hasPermission, user } = useUser();

    const modalComponent = (
        <AppointmentPreviewApp appointmentId={row.appointmentId} onDelete={() => { refreshDataGrid() }} />
    )

    const canClick = hasPermission(PERMISSIONS.APPOINTMENT_VIEW_OTHER_USER);

    const previewBtn = (record) => (
        <Button
            size="small"
            type="text"
            disabled={!canClick && record.responsibleUserId !== user.id}
            onClick={() => {
                openModal(
                    t("Appointment Preview"),
                    modalComponent,
                    () => refreshDataGrid()
                )
            }}
        >
            <PlusOutlined />
        </Button>
    );




    if (onSelect) {
        console.log("onSelect" + onSelect);
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, backgroundColor: '' }}>
                {previewBtn(onSelect)}
                {<a
                    onClick={
                        (canClick || row.responsibleUserId === user.id)
                            ? () => onSelect(row)
                            : (e) => e.preventDefault()
                    }
                >
                    {row.appointmentId}
                </a>}
            </div>
        )
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, backgroundColor: '' }}>
            {previewBtn(row)}
            {<a href={(canClick || row.responsibleUserId == user.id) ? `/app/patients/${row?.patientId}/appointments/${row.appointmentId}` : undefined}>{row.appointmentId}</a>}
        </div>
    )
}